(function ($) {
	function stats() {
		var $animation_elements = $('.u-stats .value');
		var $window = $(window);

		function check_if_in_view() {
			var window_height = $window.height();
			var window_top_position = $window.scrollTop();
			// @ts-ignore-next
			var window_bottom_position = window_top_position + window_height;

			$.each($animation_elements, function () {
				var $element = $(this);
				var countTo = $element.attr('data-count');
				var aniamtion_speed = $element.attr('data-speed');
				var element_height = $element.outerHeight();
				// @ts-ignore-next
				var element_top_position = $element.offset().top;
				var element_bottom_position =
					// @ts-ignore-next
					element_top_position + element_height;

				if (
					// @ts-ignore-next
					element_bottom_position >= window_top_position &&
					element_top_position <= window_bottom_position
				) {
					// @ts-ignore-next
					$({
						countNum: $element.text(),
					}).animate(
						{
							countNum: countTo,
						},
						{
							duration: aniamtion_speed || 1000,
							easing: 'swing',
							step: function () {
								// @ts-ignore-next
								$element.text(Math.floor(this.countNum));
							},
							complete: function () {
								$element.text(this.countNum);
							},
						}
					);
				}
			});
		}

		$window.on('scroll resize load', check_if_in_view);
	}
	stats();
})(jQuery);
